// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"2dae8a5d","344":"df0a1a15","409":"ad7bd391","578":"4b9c7dfb","721":"d8ae0e65","960":"d1e08024"}[chunkId] + ".chunk.js";
};